import { useMutation, useQueryClient } from "react-query";
import axios from "../axios";

const useEditProfile = ({ onSuccess, onError }) => {
  const queryClient = useQueryClient();
  const mutation = useMutation(
    async (params) => {
      return await axios.put(`/api/sellerprofile?id=${params?.id}`, {
        title: params?.title,
        first_name: params?.first_name,
        surname: params?.surname,
        email_address: params?.email_address,
        contact_number: params?.contact_number,
        address: params?.address,
        password: params?.password, 
        city: params?.city,
        postcode: params?.postcode,
        bank_name: params?.bank_name,
        account_number: params?.account_number,
        sort_code: params?.sort_code,
        international_bank_name: params?.international_bank_name,
        international_account_number: params?.international_account_number,
        international_sort_code: params?.international_sort_code,
        rejected_item_action: params?.rejected_item_action,
        discount: params?.discount,
        charity: params?.charity,
      });
    },
    {
      onSuccess: (res) => {
        queryClient.invalidateQueries("seller");
        onSuccess(res);
      },
      onError: (err) => onError(err),
    }
  );

  return mutation;
};

export default useEditProfile;
